import React, { useEffect, useRef, useState } from 'react'
import { Form, Row, Col, Button, Spinner, Card } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import ServerError from '../../controls/ServerError';
import { getDateSaveFormat } from '../../../Utils';
import {  useNavigate } from 'react-router-dom';
import DataGrid from '../../controls/DataGrid.js/DataGrid';


export default function PCPNewSearchClientForm({ _inputValue,_selectedUser, afterSave,  onCancel }) {
    const state = useSelector(state => state);
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [showClientList,setshowCilentList] =useState(false);
    const firstnameRef = useRef(null);
    
    const [querystring,setquerystring]=useState("");
    const [inputValue, setInputValue] = useState({
        FirstName: "",
        LastName: "",
        UCINumber:"",
        MotherName: "",
        UserId:0
    });
    const [serverError, setServerError] = useState({});
    const handleChange = ((e) => {
        const name = e.target.name;
        let value = e.target.value.trim();
        let maxLength = e.target.maxLength;
        if (e.target.type == "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength > 0 && value.length > maxLength) {
                return;
            }
        }
        setInputValue(c => ({ ...c, [name]: value }));
    });
    useEffect(() => {
       firstnameRef.current.focus();
       setshowCilentList(false);
    }, []);

    const handleSubmit = ((e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        if(inputValue.FirstName.trim()=="" && inputValue.LastName.trim()=="" && inputValue.MotherName.trim() =="" && inputValue.UCINumber.trim()=="")
        {
            window.alert("Please enter firstname or lastname or mothername or ucinumber values");
            firstnameRef.current.focus();
             setshowCilentList(false);
            return false;
        }
        if (form.checkValidity() === false) {
            setValidated(true);
        }
        else {
            let loggedinUser = JSON.parse(localStorage.getItem("user"));
            let UserId = 0;
            if (loggedinUser?.fkRoleId != 3) {
                UserId = 0
            } else {
                UserId = loggedinUser?.Id;
            }
            setLoading(true);
            setshowCilentList(true);
             setquerystring( new URLSearchParams({
                FirstName: inputValue.FirstName,
                LastName:inputValue.LastName,
                UCINumber:inputValue.UCINumber,
                MotherName: inputValue.MotherName,
                UserId: UserId
                }).toString());
            setRefreshGrid(!refreshGrid);
            setLoading(false);
        }
    })
    
    const options = {
        dataType: "server",
        showExport: true,
        showRefresh: true,
        sortName: "CreatedDate",
        sortOrder: "desc",
        exportDocumetName: "Clients",
        inputvalue: inputValue
    };
    
const columns = [
        {
            field: "FirstName",
            title: "First Name",
            sortName: "FirstName",
            sortable: true,
        },
        {
            field: "LastName",
            title: "Last Name",
            sortable: true,
        },
        {
           field: "UCINumber",
           title: "UCI Number",
           sortable: true,
          
        },
        {
            field: "MotherName",
            title: "Mother's Name",
            sortable: true,
        },
        {
            field: "user.name",
            title: "Created By",
            sortable: false,
        },
        {
                    dataField: "select",
                    title: "",
                    text: "Select",
                    formatter: (cellContent, row) => {
                        return (<div>
                            {state.access.edit ? <Button
                                className="btn-xs me-2 mb-2 p-0" variant="link"
                                onClick={() => handleSelect(row)}
                            >Select</Button> : ""}
                        </div>
                        );
                    },
                }


    ];
    const handleSelect = (row) => {
       _inputValue.FirstName = row.FirstName;
       _selectedUser =row.user;
       afterSave(row);
    };

    return (
       <Form noValidate validated={validated} onSubmit={handleSubmit} >
                   <Row className="mb-3" >
                       <Col md={6}>
                           <Row>
                               <Form.Group>
                                   <Form.Label>First Name<code className='required-symbol'>*</code></Form.Label>
                                   <Form.Control  type="text" ref={firstnameRef} name="FirstName" value={inputValue.FirstName} onChange={handleChange} autoComplete="off" />
                                   <Form.Control.Feedback type="invalid">First Name is required</Form.Control.Feedback>
                               </Form.Group>
                           </Row>
                       </Col>
                       <Col md={6}>
                           <Row>
                               <Form.Group>
                                   <Form.Label>Last Name</Form.Label>
                                   <Form.Control type="text" name="LastName" value={inputValue.LastName} onChange={handleChange} autoComplete="off" />
                               </Form.Group>
                           </Row>
                       </Col>
                       </Row>
                        <Row className="mb-3">
                       <Col md={6}>
                           <Row>
                               <Form.Group>
                                   <Form.Label>UCI Number<code className='required-symbol'>*</code></Form.Label>
                                   <Form.Control  type="text" name="UCINumber" value={inputValue.UCINumber} onChange={handleChange} autoComplete="off" />
                                   <Form.Control.Feedback type="invalid">UCI Number is required</Form.Control.Feedback>
                               </Form.Group>
                           </Row>
                       </Col>
                       <Col md={6}>
                           <Row>
                               <Form.Group>
                                   <Form.Label>Mother's Name</Form.Label>
                                   <Form.Control type="text" name="MotherName" value={inputValue.MotherName} onChange={handleChange} autoComplete="off" />
                               </Form.Group>
                           </Row>
                       </Col>
       
                   </Row>
                   
       
       
       
                   <Row className="mb-3">
                       <Col md={12}>
                           <ServerError error={serverError} />
                       </Col>
                   </Row>
                   <Row className="mb-3">
                    <Col md={9}></Col>
                       <Col className='text-center' md={3}>
                           <Button variant="outline-primary" onClick={onCancel} disabled={loading}>
                               Cancel
                               {loading ? <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> : ""}
                           </Button>&nbsp;&nbsp;
                           <Button variant="primary" type="submit" disabled={loading}>
                               Search
                               {loading ? <Spinner as="span"  animation="grow" size="sm" role="status" aria-hidden="true" /> : ""}
                           </Button>
                       </Col>
                   </Row>
                 {showClientList && 
            <Row className="mb-6">
                <Col md={12}>
                {/* {showClientList && */}
                    <h4 > 
                        Client List
                    </h4>
                {/* } */}
                </Col>
            </Row>
            }
            {showClientList && 
            <Row className="mb-6">
                <Card>
                    <Card.Body>
                        {loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}
                        
                        <DataGrid url={state.projectdetail.API + "/client/SearchClientGrid?"+querystring}   classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} />
                        
                    </Card.Body>
                </Card>
            </Row>
            }
        </Form>
    )
}
